import { Box, Button, Grid } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { ShowHideList, yesNoList } from "../../../common/Common";
import { styled, useTheme } from "@mui/material/styles";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";

interface IGeneralSettingsInfoSetupFieldsPanel {
	formMethods: any
	savedVacationPayOnPaidVacPay: any
}


export const GeneralSettingsInfoSetupFieldsPanel: FC<
	IGeneralSettingsInfoSetupFieldsPanel
> = ({ formMethods, savedVacationPayOnPaidVacPay }) => {

	const [vacationPayEnable, setVacationPayEnable] = useState(100)

	const onVacationPayOnPaidVacPaySelectionChangeHandler = (event: any) => {
		let value = event.value
		setVacationPayEnable(value)
		if (value === 200) {
			formMethods.setValue("vacationPay", 100)
		} else {
			formMethods.setValue("vacationPay", 200)
		}
	}

	useEffect(() => {
		if (savedVacationPayOnPaidVacPay) {
			setVacationPayEnable(savedVacationPayOnPaidVacPay)
		}
	}, [savedVacationPayOnPaidVacPay])
	return (
		<div style={{ padding: "0" }}>
			<EnhancedDropDownRHFWithLabel
				selectName="repeatColumnHeading"
				label="Repeat Column Heading"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Repeat-Column-Heading-list`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="timeFormat"
				label="Time Format"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Time-Format-list`}
				items={[
					{ label: "Minutes", value: 200 },
					{ label: "Fraction", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="employeeId"
				label="Employee ID"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Employee-ID-list`}
				items={[
					{ label: "Employee", value: 300 },
					{ label: "Custom ID", value: 200 },
					{ label: "Both", value: 100 },
				]}
				selectedItem={300}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="allEmployeesPaymentMethod"
				label="All Employees Payment Method"
				labelPosition={LabelPosition.Top}
				// required
				testId={`All-Employees-Payment-Method-list`}
				items={[
					// { label: "Cash", value: 300 },
					{ label: "Cheque", value: 100 },
					{ label: "Direct Deposit", value: 200 },
				]}
				// selectedItem={300}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="vacationPayonPaidVacPay"
				label="Vacation Pay on Paid Vac Pay"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Vacation-Pay-on-Paid-Vac-Pay-list`}
				items={[
					{ label: "Don't Pay", value: 100 },
					{ label: "Pay", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="payrollRemittanceMethod"
				label="Payroll Remittances Method"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Payroll-Remittances-Method-list`}
				items={[
					{ label: "Cash", value: 200 },
					{ label: "Accrual", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="vacationPayOnPaidVacPay"
				label="Vacation Pay"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Vacation-pay-list`}
				items={[
					{ label: "Calculate", value: 100 },
					{ label: "Don't Calculate", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
				onSelectionChangeHandler={onVacationPayOnPaidVacPaySelectionChangeHandler}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="vacationPay"
				label="Vacation Pay Field"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Vacation-pay-list`}
				items={ShowHideList}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
				isDisabled={vacationPayEnable === 200 ? true : false}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="payoutVacationpay"
				label="Payout Vacation Pay"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Payout-Vacation-pay-list`}
				items={yesNoList}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
				isDisabled={vacationPayEnable === 200 ? true : false}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="commission"
				label="Commission"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Commission`}
				items={ShowHideList}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
		</div>
	);
};
